import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/AppCard.css'; // Reuse existing card styles for consistency

interface MerchCardProps {
  id: string;
  name: string;
  price: number;
  description: string;
  image: string;
}

const MerchCard: React.FC<MerchCardProps> = ({ id, name, price, description, image }) => {
  const navigate = useNavigate();

  return (
    <div className="app-card merch-card" style={{ padding: '0', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Link to={`/shopping/${id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column' }}>
        {/* PRODUCT IMAGE */}
        <div style={{ position: 'relative', width: '100%', paddingTop: '100%', backgroundColor: '#fff', borderBottom: '1px solid #eee' }}>
          <img 
            src={image} 
            alt={`${name}`} 
            style={{ 
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              padding: '10px'
            }} 
          />
        </div>
        
        {/* TEXT CONTENT */}
        <div style={{ padding: '16px', flexGrow: 1 }}>
          <h3 className="app-name" style={{ fontSize: '1.1rem', marginBottom: '4px' }}>{name}</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <span className="card-price" style={{ fontSize: '1rem' }}>${price}</span>
            <span style={{ fontSize: '0.75rem', color: '#e91e63', fontWeight: 'bold' }}>Pay on Delivery</span>
          </div>
          <p className="app-desc" style={{ 
            fontSize: '0.9rem', 
            color: '#666', 
            margin: '0',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}>
            {description}
          </p>
        </div>
      </Link>
      
      {/* BUTTON AT THE BOTTOM */}
      <div style={{ padding: '0 16px 16px 16px' }}>
        <button 
          className="view-btn" 
          onClick={(e) => { e.preventDefault(); navigate(`/checkout/${id}`); }} 
          style={{ 
            width: '100%', 
            margin: '0',
            backgroundColor: '#ebebed',
            color: 'var(--primary-color)',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--primary-color)';
            e.currentTarget.style.color = '#fff';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#ebebed';
            e.currentTarget.style.color = 'var(--primary-color)';
          }}
        >
          Add to Cart
        </button>
      </div>
    </div>
  );
};

export default MerchCard;
